import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

import Spinner from '../../../../components/Spinner/';
import LoginHOC from '../../../../components/LoginHOC';

const RejectSession = gql`
mutation (
  $ModuleInstance: Int!
) {
  advisorDeclineSession (ModuleInstanceID: $ModuleInstance) {
    id
    user_id
    module_instance_id
    module_component_id
  }
}
`;


class RejectComponent extends React.Component {
  state = {
    errorOccured: false
  };

  componentDidMount() {
    this.props.RejectSession({
      variables: {
        ModuleInstance: this.props.routeParams.ModuleInstance
      },
    }).then(FormData => {
      window.location = (document.location.origin + '/modules/component/' + FormData.data.advisorDeclineSession.id + '/');
    }).catch(err =>
      this.setState({
        errorOccured: err.graphQLErrors[0].message,
      })
    )
  }

  render() {
    if (this.state.errorOccured === false) {
      return <Spinner style={{ marginTop: '50px' }} />;
    }

    return <p className='error-text' style={{ paddingTop: '40px', textAlign: 'center' }}>{this.state.errorOccured}</p>
  }
}

export default (store) => ({
  path: 'reject/:ModuleInstance',
  component: LoginHOC(compose(
    graphql(RejectSession, {
      name: 'RejectSession',
      options: {
        fetchPolicy: 'network-only',
      },
    })(RejectComponent)
  )),
});



// WEBPACK FOOTER //
// ./src/routes/scheduler/routes/SessionReject/index.js